import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import ProjectsListItem from './ProjectsListItem';
import ProjectsDetails from './details/ProjectsDetails';
import ProjectsDetailsRightSidebarSections from './details/ProjectsDetailsRightSidebar';

import buttons from './ProjectsButtons';
import events from './ProjectsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('projects'),
	routes: [
		{
			path: 'projects/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'projects'),
			element: (
				<DetailsPage
					key="projects/add"
					module="projects"
					tabs={ProjectsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'projects/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'projects'),
			element: (
				<DetailsPage
					key="projects/details"
					module="projects"
					tabs={ProjectsDetails}
					buttons={buttons.details}
					events={events}
					getRightSidebarSections={ProjectsDetailsRightSidebarSections}
				/>
			)
		},
		{
			path: 'projects/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'projects'),
			element: (
				<ViewPage
					key="projects/view"
					module="projects"
					content={{ type: 'list', itemLayout: ProjectsListItem, id: 'projectsView' }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
